import { useEffect, useMemo } from "react"

import { type InventoryByLotItem, InventoryByLotStatus } from "@/graphql/codegen/graphql"

export const LOT_QUALITY_STATUS_REFETCH_INTERVAL_MS = 5000

// A lot stays Pending until AS400 acknowledges the quality status change, so the loaded rows are refetched while any
// of them waits (AK-6411: the new status shows once AS400 confirms, with no user action). It stops once none is left
// and does not run in a background tab.
export const useLotQualityStatusAutoRefresh = (inventories: InventoryByLotItem[], refetchLoaded: () => void): void => {
  const hasPendingLot = useMemo(
    () => inventories.some((inventory) => inventory.status === InventoryByLotStatus.Pending),
    [inventories]
  )

  useEffect(() => {
    if (!hasPendingLot) return

    const intervalId = setInterval(() => {
      if (!document.hidden) refetchLoaded()
    }, LOT_QUALITY_STATUS_REFETCH_INTERVAL_MS)

    return () => clearInterval(intervalId)
  }, [hasPendingLot, refetchLoaded])
}
